// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Returns matching targets within the nearest `scope`, or the document when no scope is given. */
export function findTargets(control, selector, scope) {
  if (!selector) {
    return [];
  }

  const root = scope ? control.closest(scope) : document;

  return Array.from(root?.querySelectorAll(selector.replaceAll("/", "\\/")) || []);
}
